import WizardModalWrapperLayout from 'Views/Page/Content/Modal/Layouts/WizardModalWrapperLayout';
import React from 'react';
import WizardStepTemplateContent from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

const Layout = () => {
  const { refreshPageContentCollection } = usePageContentContext();
  const {
    resource,
  } = useMetaLayoutContext();
  return (
    <WizardModalWrapperLayout
      onSubmitSuccess={async () => {
        await refreshPageContentCollection();
      }}
      primaryActionLabel={resource.attr('primaryActionLabel') || undefined}
    >
      <WizardStepTemplateContent />
    </WizardModalWrapperLayout>
  );
};

export default Layout;
